module.exports = __webpack_public_path__ + "img/appointmentOffer.ce8a0270.png";